import { useRef } from 'react';
import { usePrevious } from './usePrevious';

export function shallowEqual(a: unknown, b: unknown) {
  if (typeof a !== typeof b) return false;

  if (typeof a === 'object' && a && typeof b === 'object' && b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    for (let i = 0; i < aKeys.length; i++) {
      if (a[aKeys[i] as keyof typeof a] !== b[bKeys[i] as keyof typeof b])
        return false;
    }
  } else {
    if (a !== b) return false;
  }

  return true;
}

/**
 * Compara con shallowEqual todos los ítems de dos arrays
 */
export function shallowCompareArrays(a: unknown[], b: unknown[]): boolean {
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; i++) {
    const differ = shallowEqual(a, b);

    if (!differ) return false;
  }

  return true;
}

export function useShallowMemo<T>(creator: () => T, deps: unknown[]): T {
  const value = useRef(creator());

  const previousDeps = usePrevious(deps);
  if (!shallowEqual(previousDeps.current ?? [], deps)) {
    value.current = creator();
  }

  return value.current;
}
